
const EmptyFinancesIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='402.116'
    height='297.347'
    viewBox='0 0 402.116 297.347'
    {...props}
  >
    <defs>
      <clipPath id='clip-path'>
        <path
          fill='none'
          d='M0 0H47.422V1.587H0z'
          data-name='Rectangle 14766'
        ></path>
      </clipPath>
      <clipPath id='clip-path-3'>
        <path
          fill='none'
          d='M0 0H47.422V1.586H0z'
          data-name='Rectangle 14770'
        ></path>
      </clipPath>
      <clipPath id='clip-path-4'>
        <path
          fill='none'
          d='M0 0H47.422V2.027H0z'
          data-name='Rectangle 14772'
        ></path>
      </clipPath>
      <clipPath id='clip-path-5'>
        <path
          fill='none'
          d='M0 0H47.422V2.293H0z'
          data-name='Rectangle 14774'
        ></path>
      </clipPath>
      <clipPath id='clip-path-6'>
        <path
          fill='none'
          d='M0 0H47.423V2.027H0z'
          data-name='Rectangle 14776'
        ></path>
      </clipPath>
      <clipPath id='clip-path-7'>
        <path
          fill='none'
          d='M0 0H6.287V30.371H0z'
          data-name='Rectangle 14815'
        ></path>
      </clipPath>
      <clipPath id='clip-path-8'>
        <path
          fill='none'
          d='M0 0H6.287V44.216H0z'
          data-name='Rectangle 14817'
        ></path>
      </clipPath>
      <clipPath id='clip-path-9'>
        <path
          fill='none'
          d='M0 0H6.288V23.663H0z'
          data-name='Rectangle 14819'
        ></path>
      </clipPath>
      <clipPath id='clip-path-10'>
        <path
          fill='none'
          d='M0 0H6.287V33.831H0z'
          data-name='Rectangle 14821'
        ></path>
      </clipPath>
      <clipPath id='clip-path-11'>
        <path
          fill='none'
          d='M0 0H6.287V27.099H0z'
          data-name='Rectangle 14823'
        ></path>
      </clipPath>
    </defs>
    <g data-name='Group 33787' transform='translate(19385 -11334)'>
      <g data-name='Group 33786' transform='translate(-19385 11334)'>
        <path
          fill='#f5f5f5'
          d='M96.886 36.33A24.725 24.725 0 1168.87 15.475 24.7 24.7 0 0196.886 36.33'
          data-name='Path 59229'
          transform='translate(-15.679 -5.002)'
        ></path>
        <path
          fill='#fbfbff'
          d='M93.946 40.052A18.842 18.842 0 1172.6 24.159a18.821 18.821 0 0121.35 15.893'
          data-name='Path 59230'
          transform='translate(-18.56 -7.877)'
        ></path>
        <path
          fill='#eff5ff'
          d='M93.689 39.117a11.111 11.111 0 01-.819-2.171 20 20 0 00-2.981-5.4 19.315 19.315 0 00-2.961-3.029 18.887 18.887 0 00-4.117-2.545 18.5 18.5 0 00-5.122-1.475 18.422 18.422 0 00-2.818-.164 18.435 18.435 0 00-5.709 1.013 18.4 18.4 0 00-2.59 1.124 18.454 18.454 0 00-4.3 3.148 18.853 18.853 0 00-2.988 3.807 19.276 19.276 0 00-1.737 3.864 20.009 20.009 0 00-.938 6.1 11.011 11.011 0 01-.021 2.318 5.524 5.524 0 01-.54-2.289A17.416 17.416 0 0156.564 37a18.884 18.884 0 014.762-8.321 18.313 18.313 0 012.108-1.861 18.517 18.517 0 012.466-1.594 19.287 19.287 0 012.786-1.234 19.307 19.307 0 016.161-1.09 19.183 19.183 0 013.041.2 19.231 19.231 0 015.486 1.669 18.883 18.883 0 017.337 6.173 17.442 17.442 0 012.7 5.842 5.536 5.536 0 01.281 2.336'
          data-name='Path 59231'
          transform='translate(-18.393 -7.527)'
        ></path>
        <path
          fill='#f5f5f5'
          d='M61.825 338.043a24.745 24.745 0 11-28.038-20.872 24.719 24.719 0 0128.038 20.872'
          data-name='Path 59237'
          transform='translate(-4.139 -104.187)'
        ></path>
        <path
          fill='#fbfbff'
          d='M58.883 341.768a18.857 18.857 0 11-21.367-15.906 18.836 18.836 0 0121.367 15.906'
          data-name='Path 59238'
          transform='translate(-7.023 -107.064)'
        ></path>
        <path
          fill='#eff5ff'
          d='M58.625 340.834a11.154 11.154 0 01-.82-2.172 20 20 0 00-2.984-5.407 19.288 19.288 0 00-2.964-3.032 18.9 18.9 0 00-4.12-2.547 18.507 18.507 0 00-5.127-1.475 18.359 18.359 0 00-2.82-.165 18.41 18.41 0 00-5.714 1.014 18.379 18.379 0 00-2.592 1.125 18.466 18.466 0 00-4.305 3.151 18.842 18.842 0 00-2.991 3.81A19.311 19.311 0 0022.45 339a20.022 20.022 0 00-.938 6.1 11.039 11.039 0 01-.021 2.321 5.536 5.536 0 01-.541-2.292 17.434 17.434 0 01.52-6.418 18.89 18.89 0 014.766-8.327 18.211 18.211 0 012.11-1.863 18.44 18.44 0 012.471-1.6 19.251 19.251 0 012.788-1.235 19.314 19.314 0 016.163-1.093 19.286 19.286 0 013.043.2 19.227 19.227 0 015.491 1.671 18.9 18.9 0 017.343 6.177 17.458 17.458 0 012.7 5.847 5.546 5.546 0 01.281 2.338'
          data-name='Path 59239'
          transform='translate(-6.855 -106.714)'
        ></path>
        <path
          fill='#f5f5f5'
          d='M367.1 25.13a15.719 15.719 0 013.838-1.668l.791-3.8 6.419-.113.924 3.768a15.738 15.738 0 013.895 1.532l3.244-2.126 4.619 4.46-2.007 3.317a15.7 15.7 0 011.668 3.84l3.8.791.113 6.418-3.768.924a15.722 15.722 0 01-1.532 3.895l2.126 3.244-4.459 4.619-3.317-2.011a15.723 15.723 0 01-3.839 1.668l-.791 3.8-6.424.112-.924-3.769a15.738 15.738 0 01-3.895-1.532l-3.244 2.126-4.619-4.459 2.011-3.317a15.715 15.715 0 01-1.669-3.839l-3.8-.791-.113-6.419 3.769-.924a15.74 15.74 0 011.532-3.894l-2.126-3.245 4.458-4.618zm3.422 8.551a6.887 6.887 0 109.738-.171 6.887 6.887 0 00-9.738.171'
          data-name='Path 59241'
          transform='translate(-117.088 -6.427)'
        ></path>
        <path
          fill='#f5f5f5'
          d='M419.35 3.521a9.922 9.922 0 012.422-1.053l.5-2.4L426.323 0l.583 2.378a9.912 9.912 0 012.458.967L431.411 2l2.915 2.815-1.27 2.095a9.932 9.932 0 011.053 2.423l2.4.5.071 4.051-2.378.583a9.942 9.942 0 01-.967 2.457l1.342 2.047-2.814 2.915-2.093-1.269a9.941 9.941 0 01-2.423 1.053l-.5 2.4-4.051.07-.583-2.378a9.937 9.937 0 01-2.458-.967l-2.047 1.342-2.915-2.815 1.269-2.093a9.941 9.941 0 01-1.053-2.423l-2.4-.5-.071-4.051 2.378-.583a9.963 9.963 0 01.967-2.458l-1.342-2.047 2.814-2.915zm2.159 5.4a4.346 4.346 0 106.145-.108 4.346 4.346 0 00-6.145.108'
          data-name='Path 59242'
          transform='translate(-135.593)'
        ></path>
        <path
          fill='#f5f5f5'
          d='M498.235 94.662a16.4 16.4 0 014-1.738l.823-3.958 6.687-.117.963 3.926a16.339 16.339 0 014.058 1.6l3.38-2.215 4.811 4.646-2.094 3.454a16.391 16.391 0 011.737 4l3.957.824.118 6.687-3.926.963a16.4 16.4 0 01-1.6 4.057l2.215 3.38-4.645 4.811-3.455-2.095a16.414 16.414 0 01-4 1.738l-.824 3.958-6.687.117-.963-3.927a16.368 16.368 0 01-4.057-1.6l-3.38 2.216-4.811-4.646 2.095-3.455a16.38 16.38 0 01-1.738-4l-3.958-.824-.117-6.687 3.926-.963a16.379 16.379 0 011.6-4.057l-2.215-3.38 4.645-4.811zm3.565 8.908a7.174 7.174 0 1010.144-.179 7.175 7.175 0 00-10.144.179'
          data-name='Path 59243'
          transform='translate(-160.048 -29.21)'
        ></path>
        <path
          fill='#f5f5f5'
          d='M11.408 195.645a16.41 16.41 0 014-1.738l.824-3.958 6.687-.117.963 3.926a16.385 16.385 0 014.058 1.6l3.38-2.215 4.811 4.646-2.095 3.454a16.379 16.379 0 011.738 4l3.957.824.117 6.687-3.926.963a16.366 16.366 0 01-1.6 4.057l2.215 3.38-4.645 4.811-3.455-2.095a16.389 16.389 0 01-4 1.738l-.824 3.958-6.687.117-.963-3.927a16.38 16.38 0 01-4.057-1.6l-3.38 2.216-4.811-4.646 2.095-3.455a16.352 16.352 0 01-1.738-4l-3.958-.824L0 206.761l3.926-.963a16.407 16.407 0 011.6-4.057l-2.215-3.38 4.645-4.811zm3.565 8.908a7.175 7.175 0 1010.144-.179 7.174 7.174 0 00-10.144.179'
          data-name='Path 59245'
          transform='translate(0 -62.409)'
        ></path>
      </g>
      <path
        fill='#00d297'
        d='M0 0H48.993V9.879H0z'
        data-name='Rectangle 14765'
        transform='translate(-19341.725 11573.03)'
      ></path>
      <path
        fill='#eff5ff'
        d='M416.409 333.693h-269.4a16.123 16.123 0 01-16.123-16.123V132.68a11.761 11.761 0 0111.762-11.761h278.77a11.114 11.114 0 0111.114 11.114V317.57a16.123 16.123 0 01-16.123 16.123'
        data-name='Path 59326'
        transform='translate(-19428.029 11294.247)'
      ></path>
      <path
        fill='#263238'
        d='M416.327 333.61s.219-.017.652-.042l.81-.045c.324-.013.693-.1 1.117-.156l.673-.106.735-.191.81-.211.857-.316a16.076 16.076 0 001.875-.837c.328-.165.642-.383.981-.581l.509-.313.494-.371a15.883 15.883 0 006.315-10.253l.139-.914c.044-.307.038-.623.061-.938.043-.632.048-1.278.041-1.937v-4.09q0-4.228-.007-9l-.053-107.708-.011-35.689q0-9.307-.005-18.985v-4.86-2.446c-.007-.816.019-1.643-.04-2.447a10.973 10.973 0 00-4.7-8.245 10.826 10.826 0 00-4.58-1.814c-.206-.028-.411-.07-.618-.087l-.624-.031c-.414-.031-.84-.019-1.262-.021h-33.868l-43.93.007L147.1 121h-3.251c-.539.008-1.088-.017-1.618.017l-.8.04c-.264.032-.528.079-.791.117a4.719 4.719 0 00-.783.159c-.257.068-.517.128-.772.2a12.381 12.381 0 00-1.48.595 11.091 11.091 0 00-2.657 1.744 11.568 11.568 0 00-2.085 2.394 12.451 12.451 0 00-1.359 2.865 12.044 12.044 0 00-.509 3.123c-.035 1.063-.009 2.142-.017 3.211V210.9c0 32.72-.007 64.282-.009 94.349v11.2a30.38 30.38 0 00.1 2.759l.207 1.357c.088.448.221.887.328 1.33a16.2 16.2 0 002.372 4.885 15.9 15.9 0 008.685 6.075c.436.1.861.247 1.3.31l1.323.2c.89.05 1.777.1 2.678.086h5.361l41.439.008 74.38.02 107.7.053 29.282.032 7.615.017c1.716.005 2.594.017 2.594.017s-.879.011-2.594.017l-7.615.017-29.282.032-107.7.053-74.38.02-41.439.008h-5.361c-.893.017-1.8-.036-2.708-.087l-1.348-.205c-.45-.064-.884-.213-1.328-.316a16.192 16.192 0 01-8.85-6.185 16.508 16.508 0 01-2.419-4.976c-.11-.452-.245-.9-.334-1.355l-.211-1.383a31.834 31.834 0 01-.1-2.792v-11.2c0-30.066-.006-61.628-.009-94.349v-49.908-25.527c.008-1.073-.017-2.139.017-3.22a12.387 12.387 0 01.524-3.213 12.754 12.754 0 011.4-2.947 11.889 11.889 0 012.144-2.462 11.463 11.463 0 012.733-1.795 12.989 12.989 0 011.523-.611c.263-.077.53-.139.795-.209a5.056 5.056 0 01.8-.164c.271-.04.542-.087.814-.119l.822-.042c.55-.036 1.085-.01 1.628-.018h3.245l195.6.013 43.93.007H420.5c.424 0 .844-.009 1.273.021l.64.033c.213.016.423.06.634.089a11.111 11.111 0 014.7 1.862 11.247 11.247 0 014.809 8.454c.06.834.034 1.647.04 2.466s0 1.632 0 2.446v23.845l-.011 35.689-.053 107.708q0 4.768-.007 9v4.09c.005.658 0 1.306-.045 1.943-.023.317-.018.635-.064.944s-.095.615-.141.918a15.943 15.943 0 01-6.373 10.291l-.5.371-.512.313c-.341.2-.657.416-.987.579a15.827 15.827 0 01-1.885.832l-.861.313-.813.208-.738.187-.675.1c-.426.055-.8.138-1.12.148l-.811.037c-.434.019-.654.024-.654.024'
        data-name='Path 59327'
        transform='translate(-19427.947 11294.33)'
      ></path>
      <path
        fill='#eff5ff'
        d='M426.039 433.612H127.686a15.588 15.588 0 01-15.586-15.588v-2.429a.6.6 0 01.6-.6h325.6a.6.6 0 01.6.6v5.151a12.865 12.865 0 01-12.865 12.866'
        data-name='Path 59328'
        transform='translate(-19421.852 11197.567)'
      ></path>
      <path
        fill='#263238'
        d='M425.956 433.53s.148-.013.44-.031a10.285 10.285 0 001.3-.117 12.84 12.84 0 007.71-4.072 12.789 12.789 0 002.419-3.826 13.249 13.249 0 00.937-5.19v-2.944-1.54c0-.264.024-.524-.172-.687-.173-.183-.442-.14-.714-.144l-72.663.053-239.728.049h-12.84a.458.458 0 00-.2.035.436.436 0 00-.248.287 3.327 3.327 0 00-.015.5v1.085c-.014.727.018 1.442.06 2.155a14.856 14.856 0 00.917 4.164 13.88 13.88 0 002.016 3.741 15.48 15.48 0 006.6 5.169 16.221 16.221 0 004.076 1.042c1.393.134 2.813.107 4.228.107h25.152l63.651.009 107.775.036 72.659.053 19.754.032 5.138.017c1.157.005 1.75.017 1.75.017s-.593.011-1.75.017l-5.138.017-19.754.032-72.659.053-107.775.036-63.651.009h-25.154c-1.412 0-2.831.029-4.265-.108a16.524 16.524 0 01-4.165-1.065 15.81 15.81 0 01-6.739-5.279 14.2 14.2 0 01-2.06-3.821 15.178 15.178 0 01-.937-4.255 27.49 27.49 0 01-.062-2.181V415.9a3.024 3.024 0 01.026-.585.769.769 0 01.438-.507.805.805 0 01.331-.062h12.837l239.728.049 72.663.053h.407a.663.663 0 01.6.555 3.751 3.751 0 01.009.4v4.484a13.35 13.35 0 01-.96 5.228 12.872 12.872 0 01-2.449 3.845 12.3 12.3 0 01-2.937 2.381 12.114 12.114 0 01-4.83 1.669 9.707 9.707 0 01-1.306.1c-.293.011-.441.013-.441.013'
        data-name='Path 59329'
        transform='translate(-19421.77 11197.649)'
      ></path>
      <path
        fill='#c5d7f2'
        d='M422.023 314.563H152.669a3.357 3.357 0 01-3.356-3.357v-167.58a3.357 3.357 0 013.356-3.357h269.354a3.357 3.357 0 013.357 3.357v167.58a3.357 3.357 0 01-3.357 3.357'
        data-name='Path 59330'
        transform='translate(-19434.088 11287.886)'
      ></path>
      <path
        fill='#263238'
        d='M421.941 314.482a5.5 5.5 0 00.578-.062 3.333 3.333 0 002.747-3.181v-3.934l-.032-26.075-.053-95.9-.011-31.777V144.125a7.451 7.451 0 00-.037-1.04 3.21 3.21 0 00-2.686-2.722 6.565 6.565 0 00-1.05-.043h-18.619l-76.007.015-174.159.013a3.2 3.2 0 00-2.429 1.1 3.108 3.108 0 00-.654 1.2 4.52 4.52 0 00-.129 1.385v165.905a6.073 6.073 0 00.247 2.42 3.218 3.218 0 001.626 1.677 3.185 3.185 0 001.151.283c.4.019.828.005 1.239.009h34.119l36.9.008 66.227.02 95.894.053 26.072.032 6.78.017c1.527.005 2.31.017 2.31.017s-.783.011-2.31.017l-6.78.017-26.072.031-95.894.054-66.227.02-36.9.008h-34.134c-.42 0-.824.01-1.256-.009a3.5 3.5 0 01-3.044-2.146 3.452 3.452 0 01-.268-1.278v-3.782-5.066-10.222-20.794-42.889-44.437V149.8v-5.767a4.857 4.857 0 01.143-1.478 3.432 3.432 0 01.722-1.32 3.532 3.532 0 012.68-1.216l174.159.013 76.007.015h18.619a6.68 6.68 0 011.091.046 3.474 3.474 0 012.906 2.947 7.8 7.8 0 01.039 1.077V153.545l-.011 31.777-.053 95.9-.031 26.075-.014 3.936a3.351 3.351 0 01-2.8 3.2 2.535 2.535 0 01-.434.042h-.146'
        data-name='Path 59331'
        transform='translate(-19434.006 11287.968)'
      ></path>
      <path
        fill='#112462'
        d='M311.281 414.461l4.055 6.881H372.4l3.766-6.881z'
        data-name='Path 59332'
        transform='translate(-19487.338 11197.742)'
      ></path>
      <path
        fill='#263238'
        d='M356.687 130.37a2.263 2.263 0 11-2.263-2.263 2.263 2.263 0 012.263 2.263'
        data-name='Path 59333'
        transform='translate(-19500.775 11291.884)'
      ></path>
      <path
        fill='#263238'
        d='M132.661 356.347a54.02 54.02 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59247'
        transform='translate(-19428.543 11216.848)'
      ></path>
      <path
        fill='#263238'
        d='M125.894 356.347a54.022 54.022 0 000 9.58 54.014 54.014 0 000-9.58'
        data-name='Path 59248'
        transform='translate(-19426.318 11216.848)'
      ></path>
      <path
        fill='#263238'
        d='M119.2 356.347a54.016 54.016 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59249'
        transform='translate(-19424.119 11216.848)'
      ></path>
      <path
        fill='#263238'
        d='M112.553 356.347a54.02 54.02 0 000 9.58 54.022 54.022 0 000-9.58'
        data-name='Path 59250'
        transform='translate(-19421.934 11216.848)'
      ></path>
      <path
        fill='#263238'
        d='M105.9 356.347a54.02 54.02 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59251'
        transform='translate(-19419.746 11216.848)'
      ></path>
      <path
        fill='#263238'
        d='M99.248 356.347a54.022 54.022 0 000 9.58 54.018 54.018 0 000-9.58'
        data-name='Path 59252'
        transform='translate(-19417.559 11216.848)'
      ></path>
      <path
        fill='#263238'
        d='M92.6 356.347a53.853 53.853 0 000 9.58 54.19 54.19 0 000-9.58'
        data-name='Path 59253'
        transform='translate(-19415.373 11216.848)'
      ></path>
      <path
        fill='#263238'
        d='M85.943 356.347a54.022 54.022 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59254'
        transform='translate(-19413.182 11216.848)'
      ></path>
      <path
        fill='#263238'
        d='M79.291 356.347a54.02 54.02 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59255'
        transform='translate(-19410.998 11216.848)'
      ></path>
      <path
        fill='#263238'
        d='M72.638 356.347a54.02 54.02 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59256'
        transform='translate(-19408.809 11216.848)'
      ></path>
      <path
        fill='#263238'
        d='M65.986 356.347a54.022 54.022 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59257'
        transform='translate(-19406.623 11216.848)'
      ></path>
      <g
        data-name='Group 33741'
        opacity='0.3'
        transform='translate(-19340.943 11573.041)'
      >
        <g data-name='Group 33740'>
          <g clipPath='url(#clip-path)' data-name='Group 33739'>
            <path
              d='M113.058 356.117a178.559 178.559 0 01-47.422.01z'
              data-name='Path 59258'
              transform='translate(-65.636 -356.117)'
            ></path>
          </g>
        </g>
      </g>
      <path
        fill='#263238'
        d='M64.45 356.044c0 .117 10.949.213 24.452.213s24.455-.1 24.455-.213-10.947-.213-24.455-.213-24.452.1-24.452.213'
        data-name='Path 59259'
        transform='translate(-19406.189 11217.019)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H48.993V9.879H0z'
        data-name='Rectangle 14767'
        transform='translate(-19342.824 11582.745)'
      ></path>
      <path
        fill='#263238'
        d='M131.022 370.819a54.02 54.02 0 000 9.58 54.024 54.024 0 000-9.58'
        data-name='Path 59260'
        transform='translate(-19428.006 11212.091)'
      ></path>
      <path
        fill='#263238'
        d='M124.255 370.819a54.022 54.022 0 000 9.58 54.018 54.018 0 000-9.58'
        data-name='Path 59261'
        transform='translate(-19425.779 11212.091)'
      ></path>
      <path
        fill='#263238'
        d='M117.566 370.819a54.018 54.018 0 000 9.58 54.022 54.022 0 000-9.58'
        data-name='Path 59262'
        transform='translate(-19423.58 11212.091)'
      ></path>
      <path
        fill='#263238'
        d='M110.914 370.819a54.02 54.02 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59263'
        transform='translate(-19421.395 11212.091)'
      ></path>
      <path
        fill='#263238'
        d='M104.261 370.819a54.016 54.016 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59264'
        transform='translate(-19419.207 11212.091)'
      ></path>
      <path
        fill='#263238'
        d='M97.609 370.819a54.02 54.02 0 000 9.58 54.022 54.022 0 000-9.58'
        data-name='Path 59265'
        transform='translate(-19417.021 11212.091)'
      ></path>
      <path
        fill='#263238'
        d='M90.956 370.819a54.022 54.022 0 000 9.58 54.016 54.016 0 000-9.58'
        data-name='Path 59266'
        transform='translate(-19414.832 11212.091)'
      ></path>
      <path
        fill='#263238'
        d='M84.3 370.819a54.022 54.022 0 000 9.58 54.018 54.018 0 000-9.58'
        data-name='Path 59267'
        transform='translate(-19412.645 11212.091)'
      ></path>
      <path
        fill='#263238'
        d='M77.651 370.819a54.022 54.022 0 000 9.58 54.19 54.19 0 000-9.58'
        data-name='Path 59268'
        transform='translate(-19410.459 11212.091)'
      ></path>
      <path
        fill='#263238'
        d='M71 370.819a54.02 54.02 0 000 9.58 54.022 54.022 0 000-9.58'
        data-name='Path 59269'
        transform='translate(-19408.271 11212.091)'
      ></path>
      <path
        fill='#263238'
        d='M64.346 370.819a54.022 54.022 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59270'
        transform='translate(-19406.084 11212.091)'
      ></path>
      <g
        data-name='Group 33744'
        opacity='0.3'
        transform='translate(-19342.043 11582.757)'
      >
        <g data-name='Group 33743'>
          <g clipPath='url(#clip-path)' data-name='Group 33742'>
            <path
              d='M111.419 370.59A178.557 178.557 0 0164 370.6z'
              data-name='Path 59271'
              transform='translate(-63.997 -370.59)'
            ></path>
          </g>
        </g>
      </g>
      <path
        fill='#263238'
        d='M62.811 370.516c0 .118 10.949.213 24.452.213s24.455-.1 24.455-.213-10.947-.213-24.455-.213-24.452.1-24.452.213'
        data-name='Path 59272'
        transform='translate(-19405.65 11212.26)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H48.993V9.879H0z'
        data-name='Rectangle 14769'
        transform='translate(-19338.174 11592.306)'
      ></path>
      <path
        fill='#263238'
        d='M137.952 385.062a54.028 54.028 0 000 9.58 54.013 54.013 0 000-9.58'
        data-name='Path 59273'
        transform='translate(-19430.283 11207.407)'
      ></path>
      <path
        fill='#263238'
        d='M131.184 385.062a54.02 54.02 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59274'
        transform='translate(-19428.057 11207.407)'
      ></path>
      <path
        fill='#263238'
        d='M124.5 385.062a54.018 54.018 0 000 9.58 54.193 54.193 0 000-9.58'
        data-name='Path 59275'
        transform='translate(-19425.859 11207.407)'
      ></path>
      <path
        fill='#263238'
        d='M117.843 385.062a54.018 54.018 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59276'
        transform='translate(-19423.672 11207.407)'
      ></path>
      <path
        fill='#263238'
        d='M111.191 385.062a54.022 54.022 0 000 9.58 54.018 54.018 0 000-9.58'
        data-name='Path 59277'
        transform='translate(-19421.484 11207.407)'
      ></path>
      <path
        fill='#263238'
        d='M104.538 385.062a54.022 54.022 0 000 9.58 54.018 54.018 0 000-9.58'
        data-name='Path 59278'
        transform='translate(-19419.299 11207.407)'
      ></path>
      <path
        fill='#263238'
        d='M97.886 385.062a54.02 54.02 0 000 9.58 54.022 54.022 0 000-9.58'
        data-name='Path 59279'
        transform='translate(-19417.109 11207.407)'
      ></path>
      <path
        fill='#263238'
        d='M91.234 385.062a54.02 54.02 0 000 9.58 54.191 54.191 0 000-9.58'
        data-name='Path 59280'
        transform='translate(-19414.926 11207.407)'
      ></path>
      <path
        fill='#263238'
        d='M84.581 385.062a54.018 54.018 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59281'
        transform='translate(-19412.736 11207.407)'
      ></path>
      <path
        fill='#263238'
        d='M77.929 385.062a54.022 54.022 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59282'
        transform='translate(-19410.551 11207.407)'
      ></path>
      <path
        fill='#263238'
        d='M71.276 385.062a54.022 54.022 0 000 9.58 54.02 54.02 0 000-9.58'
        data-name='Path 59283'
        transform='translate(-19408.361 11207.407)'
      ></path>
      <g
        data-name='Group 33747'
        opacity='0.3'
        transform='translate(-19337.393 11592.316)'
      >
        <g data-name='Group 33746'>
          <g clipPath='url(#clip-path-3)' data-name='Group 33745'>
            <path
              d='M118.349 384.833a178.561 178.561 0 01-47.422.01z'
              data-name='Path 59284'
              transform='translate(-70.927 -384.833)'
            ></path>
          </g>
        </g>
      </g>
      <path
        fill='#263238'
        d='M69.741 384.759c0 .117 10.949.213 24.452.213s24.455-.1 24.455-.213-10.947-.213-24.455-.213-24.452.1-24.452.213'
        data-name='Path 59285'
        transform='translate(-19407.928 11207.577)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H48.993V9.501H0z'
        data-name='Rectangle 14771'
        transform='translate(-19343.912 11602.11)'
      ></path>
      <path
        fill='#263238'
        d='M129.4 399.662a49.974 49.974 0 000 9.214 49.974 49.974 0 000-9.214'
        data-name='Path 59286'
        transform='translate(-19427.471 11202.608)'
      ></path>
      <path
        fill='#263238'
        d='M122.634 399.662a49.969 49.969 0 000 9.214 49.98 49.98 0 000-9.214'
        data-name='Path 59287'
        transform='translate(-19425.248 11202.608)'
      ></path>
      <path
        fill='#263238'
        d='M115.946 399.662a49.976 49.976 0 000 9.214 49.976 49.976 0 000-9.214'
        data-name='Path 59288'
        transform='translate(-19423.047 11202.608)'
      ></path>
      <path
        fill='#263238'
        d='M109.293 399.662a49.976 49.976 0 000 9.214 49.971 49.971 0 000-9.214'
        data-name='Path 59289'
        transform='translate(-19420.861 11202.608)'
      ></path>
      <path
        fill='#263238'
        d='M102.641 399.662a49.976 49.976 0 000 9.214 49.976 49.976 0 000-9.214'
        data-name='Path 59290'
        transform='translate(-19418.674 11202.608)'
      ></path>
      <path
        fill='#263238'
        d='M95.988 399.662a49.974 49.974 0 000 9.214 49.978 49.978 0 000-9.214'
        data-name='Path 59291'
        transform='translate(-19416.488 11202.608)'
      ></path>
      <path
        fill='#263238'
        d='M89.336 399.662a49.974 49.974 0 000 9.214 49.974 49.974 0 000-9.214'
        data-name='Path 59292'
        transform='translate(-19414.299 11202.608)'
      ></path>
      <path
        fill='#263238'
        d='M82.683 399.662a49.974 49.974 0 000 9.214 49.972 49.972 0 000-9.214'
        data-name='Path 59293'
        transform='translate(-19412.113 11202.608)'
      ></path>
      <path
        fill='#263238'
        d='M76.031 399.662a49.974 49.974 0 000 9.214 49.974 49.974 0 000-9.214'
        data-name='Path 59294'
        transform='translate(-19409.926 11202.608)'
      ></path>
      <path
        fill='#263238'
        d='M69.378 399.662a49.976 49.976 0 000 9.214 49.972 49.972 0 000-9.214'
        data-name='Path 59295'
        transform='translate(-19407.74 11202.608)'
      ></path>
      <path
        fill='#263238'
        d='M62.726 399.662a49.974 49.974 0 000 9.214 49.974 49.974 0 000-9.214'
        data-name='Path 59296'
        transform='translate(-19405.553 11202.608)'
      ></path>
      <g
        data-name='Group 33750'
        opacity='0.3'
        transform='translate(-19343.131 11602.121)'
      >
        <g data-name='Group 33749'>
          <g clipPath='url(#clip-path-4)' data-name='Group 33748'>
            <path
              d='M109.8 399.441a140.17 140.17 0 01-47.422.013z'
              data-name='Path 59297'
              transform='translate(-62.376 -399.441)'
            ></path>
          </g>
        </g>
      </g>
      <path
        fill='#263238'
        d='M61.19 399.366c0 .117 10.949.213 24.452.213s24.455-.1 24.455-.213-10.947-.213-24.455-.213-24.452.1-24.452.213'
        data-name='Path 59298'
        transform='translate(-19405.115 11202.775)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H48.993V9.501H0z'
        data-name='Rectangle 14773'
        transform='translate(-19340.764 11611.619)'
      ></path>
      <path
        fill='#263238'
        d='M134.095 413.825a49.977 49.977 0 000 9.213 49.97 49.97 0 000-9.213'
        data-name='Path 59299'
        transform='translate(-19429.016 11197.952)'
      ></path>
      <path
        fill='#263238'
        d='M127.327 413.825a49.972 49.972 0 000 9.213 49.974 49.974 0 000-9.213'
        data-name='Path 59300'
        transform='translate(-19426.789 11197.952)'
      ></path>
      <path
        fill='#263238'
        d='M120.639 413.825a49.979 49.979 0 000 9.213 49.969 49.969 0 000-9.213'
        data-name='Path 59301'
        transform='translate(-19424.592 11197.952)'
      ></path>
      <path
        fill='#263238'
        d='M113.986 413.825a49.97 49.97 0 000 9.213 49.976 49.976 0 000-9.213'
        data-name='Path 59302'
        transform='translate(-19422.404 11197.952)'
      ></path>
      <path
        fill='#263238'
        d='M107.333 413.825a49.817 49.817 0 000 9.213 50.131 50.131 0 000-9.213'
        data-name='Path 59303'
        transform='translate(-19420.217 11197.952)'
      ></path>
      <path
        fill='#263238'
        d='M100.681 413.825a49.974 49.974 0 000 9.213 49.974 49.974 0 000-9.213'
        data-name='Path 59304'
        transform='translate(-19418.031 11197.952)'
      ></path>
      <path
        fill='#263238'
        d='M94.029 413.825a49.974 49.974 0 000 9.213 49.976 49.976 0 000-9.213'
        data-name='Path 59305'
        transform='translate(-19415.842 11197.952)'
      ></path>
      <path
        fill='#263238'
        d='M87.376 413.825a49.97 49.97 0 000 9.213 50.135 50.135 0 000-9.213'
        data-name='Path 59306'
        transform='translate(-19413.658 11197.952)'
      ></path>
      <path
        fill='#263238'
        d='M80.724 413.825a49.974 49.974 0 000 9.213 49.976 49.976 0 000-9.213'
        data-name='Path 59307'
        transform='translate(-19411.469 11197.952)'
      ></path>
      <path
        fill='#263238'
        d='M74.071 413.825a49.974 49.974 0 000 9.213 49.976 49.976 0 000-9.213'
        data-name='Path 59308'
        transform='translate(-19409.281 11197.952)'
      ></path>
      <path
        fill='#263238'
        d='M67.419 413.825a49.974 49.974 0 000 9.213 49.976 49.976 0 000-9.213'
        data-name='Path 59309'
        transform='translate(-19407.094 11197.952)'
      ></path>
      <g
        data-name='Group 33753'
        opacity='0.3'
        transform='translate(-19339.982 11611.629)'
      >
        <g data-name='Group 33752'>
          <g clipPath='url(#clip-path-5)' data-name='Group 33751'>
            <path
              d='M114.491 413.605a124.12 124.12 0 01-47.422.015z'
              data-name='Path 59310'
              transform='translate(-67.069 -413.605)'
            ></path>
          </g>
        </g>
      </g>
      <path
        fill='#263238'
        d='M65.883 413.53c0 .117 10.949.213 24.453.213s24.454-.1 24.454-.213-10.947-.213-24.454-.213-24.453.1-24.453.213'
        data-name='Path 59311'
        transform='translate(-19406.66 11198.119)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0h48.993v9.5H0z'
        data-name='Path 59429'
        transform='translate(-19343.564 11620.991)'
      ></path>
      <path
        fill='#263238'
        d='M129.925 427.787a49.974 49.974 0 000 9.213 50.135 50.135 0 000-9.213'
        data-name='Path 59312'
        transform='translate(-19427.643 11193.361)'
      ></path>
      <path
        fill='#263238'
        d='M123.157 427.787a49.972 49.972 0 000 9.213 49.975 49.975 0 000-9.213'
        data-name='Path 59313'
        transform='translate(-19425.42 11193.361)'
      ></path>
      <path
        fill='#263238'
        d='M116.469 427.787a49.974 49.974 0 000 9.213 50.129 50.129 0 000-9.213'
        data-name='Path 59314'
        transform='translate(-19423.221 11193.361)'
      ></path>
      <path
        fill='#263238'
        d='M109.816 427.787a49.975 49.975 0 000 9.213 49.972 49.972 0 000-9.213'
        data-name='Path 59315'
        transform='translate(-19421.033 11193.361)'
      ></path>
      <path
        fill='#263238'
        d='M103.164 427.787a49.968 49.968 0 000 9.213 49.975 49.975 0 000-9.213'
        data-name='Path 59316'
        transform='translate(-19418.846 11193.361)'
      ></path>
      <path
        fill='#263238'
        d='M96.511 427.787a49.972 49.972 0 000 9.213 49.975 49.975 0 000-9.213'
        data-name='Path 59317'
        transform='translate(-19416.658 11193.361)'
      ></path>
      <path
        fill='#263238'
        d='M89.859 427.787a49.975 49.975 0 000 9.213 49.975 49.975 0 000-9.213'
        data-name='Path 59318'
        transform='translate(-19414.471 11193.361)'
      ></path>
      <path
        fill='#263238'
        d='M83.206 427.787a49.974 49.974 0 000 9.213 49.974 49.974 0 000-9.213'
        data-name='Path 59319'
        transform='translate(-19412.285 11193.361)'
      ></path>
      <path
        fill='#263238'
        d='M76.554 427.787a49.975 49.975 0 000 9.213 49.974 49.974 0 000-9.213'
        data-name='Path 59320'
        transform='translate(-19410.098 11193.361)'
      ></path>
      <path
        fill='#263238'
        d='M69.9 427.787a49.974 49.974 0 000 9.213 49.974 49.974 0 000-9.213'
        data-name='Path 59321'
        transform='translate(-19407.91 11193.361)'
      ></path>
      <path
        fill='#263238'
        d='M63.249 427.787a49.974 49.974 0 000 9.213 49.973 49.973 0 000-9.213'
        data-name='Path 59322'
        transform='translate(-19405.725 11193.361)'
      ></path>
      <g
        data-name='Group 33756'
        opacity='0.3'
        transform='translate(-19342.779 11621)'
      >
        <g data-name='Group 33755'>
          <g clipPath='url(#clip-path-6)' data-name='Group 33754'>
            <path
              d='M110.322 427.566a140.175 140.175 0 01-47.423.013z'
              data-name='Path 59323'
              transform='translate(-62.899 -427.566)'
            ></path>
          </g>
        </g>
      </g>
      <path
        fill='#263238'
        d='M61.713 427.491c0 .117 10.949.213 24.452.213s24.455-.1 24.455-.213-10.947-.213-24.455-.213-24.452.1-24.452.213'
        data-name='Path 59324'
        transform='translate(-19405.287 11193.529)'
      ></path>
      <path
        fill='#263238'
        d='M134.422 413.578a.652.652 0 01-.015-.162c0-.124-.009-.282-.015-.478l-.028-1.849-.048-6.882v-.107h.107l2.7-.011-.117.117-.028-9.507.146.145-3.15.006h-.151v-.15c0-2.937-.006-6.12-.009-9.428v-.16h5.9l-.16.16c0-3.515.007-6.893.009-10.061l.151.151-4.651-.008h-.144v-.142l.029-9.214v-.113h.113l1.2.005-.108.109-.024-7.233c0-.83.007-1.479.009-1.943 0-.207.007-.373.01-.5a.7.7 0 01.014-.17.756.756 0 01.017.17l.02.5.048 1.943.122 7.232v.109h-.11l-1.2.005.113-.113.03 9.214-.142-.143 4.651-.008h.151v.152c0 3.168.005 6.545.009 10.061v.16h-5.9l.16-.16c0 3.308-.006 6.491-.009 9.428l-.151-.151 3.15.006h.146v.145l-.028 9.507v.119h-.117l-2.7-.012.106-.105-.048 6.882-.028 1.849-.015.478a.653.653 0 01-.015.162'
        data-name='Path 59325'
        transform='translate(-19428.992 11216.914)'
      ></path>
      <path
        fill='#fff'
        d='M219.086 238.953H44.3a6.615 6.615 0 01-6.615-6.615v-114.52a5.092 5.092 0 015.091-5.092h177.58a6.614 6.614 0 016.614 6.614v111.729a7.885 7.885 0 01-7.884 7.884'
        data-name='Path 59376'
        transform='translate(-19397.389 11296.94)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H31.141V12.492H0z'
        data-name='Rectangle 14787'
        transform='translate(-19324.576 11454.828)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H31.141V12.492H0z'
        data-name='Rectangle 14788'
        transform='translate(-19231.154 11454.828)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H31.141V12.493H0z'
        data-name='Rectangle 14789'
        transform='translate(-19231.154 11479.64)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H31.141V12.493H0z'
        data-name='Rectangle 14790'
        transform='translate(-19231.154 11492.046)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H31.141V12.492H0z'
        data-name='Rectangle 14791'
        transform='translate(-19293.436 11479.864)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H31.141V12.492H0z'
        data-name='Rectangle 14792'
        transform='translate(-19262.344 11492.51)'
      ></path>
      <path
        fill='#fbfbff'
        d='M0 0H31.141V12.998H0z'
        data-name='Rectangle 14793'
        transform='translate(-19293.436 11517.29)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H31.141V12.493H0z'
        data-name='Rectangle 14794'
        transform='translate(-19231.154 11517.464)'
      ></path>
      <path
        fill='#eff5ff'
        d='M0 0H168.141V12.209H0z'
        data-name='Rectangle 14795'
        transform='translate(-19344.311 11442.621)'
      ></path>
      <path
        fill='#eff5ff'
        d='M0 0H29.478V87.929H0z'
        data-name='Rectangle 14796'
        transform='translate(-19354.053 11442.621)'
      ></path>
      <path
        fill='#eff5ff'
        d='M75.8 249.966H45.469v-88.779H75.8zm-29.479-.848h28.63v-87.08H46.317z'
        data-name='Path 59377'
        transform='translate(-19399.949 11281.009)'
      ></path>
      <path
        fill='#eff5ff'
        d='M226.971 127.046H37.685v-9.229a5.091 5.091 0 015.091-5.091h177.58a6.615 6.615 0 016.614 6.614z'
        data-name='Path 59378'
        transform='translate(-19397.389 11296.94)'
      ></path>
      <path
        fill='#fbfbff'
        d='M0 0H29.143V8.195H0z'
        data-name='Rectangle 14797'
        transform='translate(-19353.721 11429.206)'
      ></path>
      <path
        fill='#fbfbff'
        d='M0 0H28.105V8.195H0z'
        data-name='Rectangle 14798'
        transform='translate(-19321.164 11429.206)'
      ></path>
      <path
        fill='#fbfbff'
        d='M0 0H28.105V8.195H0z'
        data-name='Rectangle 14799'
        transform='translate(-19290.338 11429.206)'
      ></path>
      <path
        fill='#fbfbff'
        d='M0 0H28.105V8.195H0z'
        data-name='Rectangle 14800'
        transform='translate(-19259.514 11429.206)'
      ></path>
      <path
        fill='#fbfbff'
        d='M0 0H28.105V8.195H0z'
        data-name='Rectangle 14801'
        transform='translate(-19228.693 11429.206)'
      ></path>
      <path
        fill='#fbfbff'
        d='M0 0H23.102V8.195H0z'
        data-name='Rectangle 14802'
        transform='translate(-19197.867 11429.206)'
      ></path>
      <path
        fill='#263238'
        d='M46.021 249.379s.3-.009.87-.013l2.541-.013 9.834-.025 36.845-.058 127.8-.1-.209.209c0-27.113-.008-56.768-.013-87.655v-.012l.221.221-177.887-.058.164-.163-.088 64.067-.041 17.477-.018 4.558c-.005 1.034-.017 1.565-.017 1.565s-.011-.513-.017-1.532-.01-2.543-.017-4.528l-.041-17.44-.088-64.167v-.164h.164l177.887-.058h.221v.234c0 30.887-.009 60.541-.013 87.655v.209h-.208l-127.937-.1-36.8-.058-9.791-.025-2.517-.013c-.563 0-.844-.013-.844-.013'
        data-name='Path 59379'
        transform='translate(-19400.076 11280.908)'
      ></path>
      <path
        fill='#263238'
        d='M224.487 179.9c0 .122-39.824.221-88.939.221-49.132 0-88.948-.1-88.948-.221s39.816-.221 88.948-.221c49.115 0 88.939.1 88.939.221'
        data-name='Path 59380'
        transform='translate(-19400.32 11274.929)'
      ></path>
      <path
        fill='#263238'
        d='M224.487 198.51c0 .122-39.824.221-88.939.221-49.132 0-88.948-.1-88.948-.221s39.816-.221 88.948-.221c49.115 0 88.939.1 88.939.221'
        data-name='Path 59381'
        transform='translate(-19400.32 11268.811)'
      ></path>
      <path
        fill='#263238'
        d='M224.487 217.121c0 .122-39.824.221-88.939.221-49.132 0-88.948-.1-88.948-.221s39.816-.221 88.948-.221c49.115 0 88.939.1 88.939.221'
        data-name='Path 59382'
        transform='translate(-19400.32 11262.692)'
      ></path>
      <path
        fill='#263238'
        d='M224.487 235.731c0 .122-39.824.221-88.939.221-49.132 0-88.948-.1-88.948-.221s39.816-.221 88.948-.221c49.115 0 88.939.1 88.939.221'
        data-name='Path 59383'
        transform='translate(-19400.32 11256.574)'
      ></path>
      <path
        fill='#263238'
        d='M224.487 254.342c0 .122-39.824.221-88.939.221-49.132 0-88.948-.1-88.948-.221s39.816-.221 88.948-.221c49.115 0 88.939.1 88.939.221'
        data-name='Path 59384'
        transform='translate(-19400.32 11250.456)'
      ></path>
      <path
        fill='#263238'
        d='M224.487 272.953c0 .122-39.824.221-88.939.221-49.132 0-88.948-.1-88.948-.221s39.816-.221 88.948-.221c49.115 0 88.939.1 88.939.221'
        data-name='Path 59385'
        transform='translate(-19400.32 11244.337)'
      ></path>
      <path
        fill='#263238'
        d='M89.91 249.99c-.122 0-.221-19.575-.221-43.717s.1-43.721.221-43.721.221 19.571.221 43.721-.1 43.717-.221 43.717'
        data-name='Path 59386'
        transform='translate(-19414.484 11280.559)'
      ></path>
      <path
        fill='#263238'
        d='M136.3 249.728c-.122 0-.221-19.516-.221-43.586s.1-43.59.221-43.59.221 19.513.221 43.59-.1 43.586-.221 43.586'
        data-name='Path 59387'
        transform='translate(-19429.736 11280.559)'
      ></path>
      <path
        fill='#263238'
        d='M182.7 249.99c-.122 0-.221-19.575-.221-43.717s.1-43.721.221-43.721.221 19.571.221 43.721-.1 43.717-.221 43.717'
        data-name='Path 59388'
        transform='translate(-19444.99 11280.559)'
      ></path>
      <path
        fill='#263238'
        d='M229.09 249.99c-.122 0-.221-19.575-.221-43.717s.1-43.721.221-43.721.221 19.571.221 43.721-.1 43.717-.221 43.717'
        data-name='Path 59389'
        transform='translate(-19460.242 11280.559)'
      ></path>
      <path
        fill='#263238'
        d='M275.483 249.99c-.122 0-.221-19.575-.221-43.717s.1-43.721.221-43.721.221 19.571.221 43.721-.1 43.717-.221 43.717'
        data-name='Path 59390'
        transform='translate(-19475.494 11280.559)'
      ></path>
      <path
        fill='#fff'
        d='M52.4 122.484a1.806 1.806 0 11-1.806-1.859 1.833 1.833 0 011.806 1.859'
        data-name='Path 59391'
        transform='translate(-19401.041 11294.345)'
      ></path>
      <path
        fill='#fff'
        d='M61.541 122.484a1.806 1.806 0 11-1.806-1.859 1.833 1.833 0 011.806 1.859'
        data-name='Path 59392'
        transform='translate(-19404.045 11294.345)'
      ></path>
      <path
        fill='#fff'
        d='M70.68 122.484a1.806 1.806 0 11-1.806-1.859 1.833 1.833 0 011.806 1.859'
        data-name='Path 59393'
        transform='translate(-19407.051 11294.345)'
      ></path>
      <path
        fill='#263238'
        d='M219 238.868s.136-.013.4-.03a8.467 8.467 0 001.184-.148 7.878 7.878 0 005.818-5.145 8.346 8.346 0 00.263-.935 9.627 9.627 0 00.138-1.006c.05-.689.021-1.418.028-2.172 0-3.019-.01-6.5-.016-10.42l-.056-66.411-.011-22.006c-.009-3.823.015-7.737-.023-11.7a6.446 6.446 0 00-5.531-6.038 29.248 29.248 0 00-3.053-.072l-52.636.016-120.605.015h-2a5.234 5.234 0 00-1.9.308 4.933 4.933 0 00-2.761 2.547 4.876 4.876 0 00-.446 1.857c-.021.649-.006 1.322-.011 1.981V169.99c0 20.176-.007 39.636-.01 58.175v3.466a7.112 7.112 0 00.582 3.29 6.476 6.476 0 005.144 3.745c.545.052 1.107.046 1.672.044h11.672l25.551.009 45.863.021 66.407.056 18.055.032 4.7.017c1.058.006 1.6.018 1.6.018s-.542.012-1.6.018l-4.7.017-18.055.032-66.407.056-45.863.021-25.551.009H45.157c-.56 0-1.126.009-1.707-.045a6.794 6.794 0 01-5.4-3.926 7.422 7.422 0 01-.612-3.423v-3.466c0-18.538-.007-38-.011-58.175v-30.772-15.74-3.969c.005-.665-.011-1.318.011-2a5.228 5.228 0 01.479-1.99 5.283 5.283 0 012.953-2.71 5.611 5.611 0 012.023-.33h2l120.608.014 52.636.016a28.938 28.938 0 013.094.077 6.73 6.73 0 015.771 6.308c.036 3.991.007 7.884.013 11.713l-.011 22.006-.055 66.411-.016 10.42c-.009.756.017 1.479-.036 2.18a9.629 9.629 0 01-.144 1.017 8.466 8.466 0 01-.27.944 7.733 7.733 0 01-7.084 5.283c-.268.011-.4.011-.4.011'
        data-name='Path 59394'
        transform='translate(-19397.303 11297.025)'
      ></path>
      <path
        fill='#fff'
        d='M415.512 264.933H270.046a5.087 5.087 0 01-5.087-5.087V57.817a5.059 5.059 0 015.059-5.059H415.06a6.075 6.075 0 016.075 6.075v200.478a5.622 5.622 0 01-5.622 5.622'
        data-name='Path 59395'
        transform='translate(-19472.105 11316.655)'
      ></path>
      <path
        fill='#eff5ff'
        d='M421.134 72.1H264.958V57.817a5.059 5.059 0 015.059-5.059h145.042a6.075 6.075 0 016.075 6.075z'
        data-name='Path 59396'
        transform='translate(-19472.105 11316.655)'
      ></path>
      <path
        fill='#fff'
        d='M281.979 65.448a2.569 2.569 0 11-2.565-2.437 2.5 2.5 0 012.565 2.437'
        data-name='Path 59397'
        transform='translate(-19476.014 11313.284)'
      ></path>
      <path
        fill='#fff'
        d='M294.866 65.448a2.569 2.569 0 11-2.565-2.437 2.5 2.5 0 012.565 2.437'
        data-name='Path 59398'
        transform='translate(-19480.252 11313.284)'
      ></path>
      <path
        fill='#fff'
        d='M307.752 65.448a2.569 2.569 0 11-2.566-2.437 2.5 2.5 0 012.566 2.437'
        data-name='Path 59399'
        transform='translate(-19484.488 11313.284)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H6.287V45.992H0z'
        data-name='Rectangle 14804'
        transform='translate(-19183.789 11423.304)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H6.288V30.371H0z'
        data-name='Rectangle 14805'
        transform='translate(-19171.652 11438.926)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H6.287V40.509H0z'
        data-name='Rectangle 14806'
        transform='translate(-19159.514 11429.021)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H6.287V44.215H0z'
        data-name='Rectangle 14807'
        transform='translate(-19147.375 11425.081)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H6.288V29.436H0z'
        data-name='Rectangle 14808'
        transform='translate(-19135.238 11439.86)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H6.288V23.663H0z'
        data-name='Rectangle 14809'
        transform='translate(-19123.102 11445.633)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H6.288V41.271H0z'
        data-name='Rectangle 14810'
        transform='translate(-19110.963 11428.025)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H6.288V33.831H0z'
        data-name='Rectangle 14811'
        transform='translate(-19098.826 11435.466)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H6.288V39.776H0z'
        data-name='Rectangle 14812'
        transform='translate(-19086.688 11429.521)'
      ></path>
      <path
        fill='#00d297'
        d='M0 0H6.288V27.099H0z'
        data-name='Rectangle 14813'
        transform='translate(-19074.551 11442.198)'
      ></path>
      <g data-name='Group 33766' transform='translate(-19171.652 11438.925)'>
        <g clipPath='url(#clip-path-7)' data-name='Group 33765'>
          <path
            fill='#fff'
            d='M0 0H6.288V30.371H0z'
            data-name='Rectangle 14814'
            transform='translate(-.001)'
          ></path>
        </g>
      </g>
      <g data-name='Group 33769' transform='translate(-19147.377 11425.08)'>
        <g clipPath='url(#clip-path-8)' data-name='Group 33768'>
          <path
            fill='#fff'
            d='M0 0H6.287V44.215H0z'
            data-name='Rectangle 14816'
            transform='translate(0 .001)'
          ></path>
        </g>
      </g>
      <g data-name='Group 33772' transform='translate(-19123.102 11445.633)'>
        <g clipPath='url(#clip-path-9)' data-name='Group 33771'>
          <path
            fill='#fff'
            d='M0 0H6.288V23.663H0z'
            data-name='Rectangle 14818'
          ></path>
        </g>
      </g>
      <g data-name='Group 33775' transform='translate(-19098.826 11435.466)'>
        <g clipPath='url(#clip-path-10)' data-name='Group 33774'>
          <path
            fill='#fff'
            d='M0 0H6.288V33.831H0z'
            data-name='Rectangle 14820'
            transform='translate(-.001)'
          ></path>
        </g>
      </g>
      <g data-name='Group 33778' transform='translate(-19074.551 11442.198)'>
        <g clipPath='url(#clip-path-11)' data-name='Group 33777'>
          <path
            fill='#fff'
            d='M0 0H6.288V27.099H0z'
            data-name='Rectangle 14822'
            transform='translate(-.001)'
          ></path>
        </g>
      </g>
      <path
        fill='#263238'
        d='M290.015 135.689s.008.07.012.207.007.35.012.612l.023 2.386.042 9.045.063 32.2-.153-.152 41.708-.022 60.931.051 18.464.056 5.02.033 1.306.017c.294.006.445.018.445.018s-.151.011-.445.017l-1.306.017-5.02.033-18.464.056-60.931.051-41.708-.022h-.153v-.153l.063-32.2.043-9.045.023-2.386.012-.612c.003-.148.012-.207.012-.207'
        data-name='Path 59400'
        transform='translate(-19480.293 11289.392)'
      ></path>
      <path
        fill='#eff5ff'
        d='M326.189 113.705H292.3a1.717 1.717 0 01-1.716-1.716v-.433a1.716 1.716 0 011.716-1.716h33.892a1.716 1.716 0 011.716 1.716v.433a1.717 1.717 0 01-1.716 1.716'
        data-name='Path 59401'
        transform='translate(-19480.531 11297.89)'
      ></path>
      <path
        fill='#eff5ff'
        d='M406.416 229.633H287.084a1.717 1.717 0 01-1.716-1.716v-.433a1.716 1.716 0 011.716-1.716h119.332a1.716 1.716 0 011.716 1.716v.433a1.717 1.717 0 01-1.716 1.716'
        data-name='Path 59402'
        transform='translate(-19478.816 11259.778)'
      ></path>
      <path
        fill='#eff5ff'
        d='M406.416 261.66H287.084a1.717 1.717 0 01-1.716-1.716v-.433a1.716 1.716 0 011.716-1.716h119.332a1.716 1.716 0 011.716 1.716v.433a1.717 1.717 0 01-1.716 1.716'
        data-name='Path 59403'
        transform='translate(-19478.816 11249.248)'
      ></path>
      <path
        fill='#eff5ff'
        d='M350.291 245.576h-63.207a1.717 1.717 0 01-1.716-1.716v-.433a1.716 1.716 0 011.716-1.716h63.207a1.716 1.716 0 011.716 1.716v.433a1.717 1.717 0 01-1.716 1.716'
        data-name='Path 59404'
        transform='translate(-19478.816 11254.535)'
      ></path>
      <path
        fill='#eff5ff'
        d='M441.83 245.576h-44.589a1.716 1.716 0 01-1.716-1.716v-.433a1.715 1.715 0 011.716-1.716h44.589a1.716 1.716 0 011.716 1.716v.433a1.717 1.717 0 01-1.716 1.716'
        data-name='Path 59405'
        transform='translate(-19515.033 11254.535)'
      ></path>
      <path
        fill='#eff5ff'
        d='M332.865 277.744h-44.589a1.716 1.716 0 01-1.716-1.716v-.433a1.715 1.715 0 011.716-1.716h44.589a1.716 1.716 0 011.716 1.716v.433a1.717 1.717 0 01-1.716 1.716'
        data-name='Path 59406'
        transform='translate(-19479.209 11243.96)'
      ></path>
      <path
        fill='#263238'
        d='M415.426 264.848a6.132 6.132 0 001.836-.332 5.614 5.614 0 003.564-3.876 6.54 6.54 0 00.184-1.9v-2.137q0-2.242-.008-4.9c0-3.543-.01-7.629-.016-12.229l-.056-77.936c-.007-16.452-.013-34.474-.022-53.819q0-14.51-.009-29.982V60.067c-.005-.663.019-1.338-.04-1.978a5.909 5.909 0 00-5.093-5.2 17.347 17.347 0 00-2.006-.058h-2.036l-141.536.013a4.886 4.886 0 00-5 3.788 10.078 10.078 0 00-.128 2.292v63.914c0 23.676-.007 46.514-.01 68.269s-.011 42.429-.016 61.776c.006 2.414-.017 4.826.013 7.184a4.888 4.888 0 001.349 3.1 4.95 4.95 0 002.994 1.5c.558.057 1.149.033 1.728.038h11.989l25.825.011 77.931.056 21.188.033 5.51.017c1.242.006 1.877.018 1.877.018s-.636.012-1.877.018l-5.51.017-21.188.032-77.931.056-25.825.011H271.1c-.582-.006-1.158.021-1.761-.04a5.225 5.225 0 01-3.166-1.586 5.173 5.173 0 01-1.429-3.273c-.034-2.394-.011-4.779-.019-7.2l-.016-61.776c-.005-21.755-.007-44.593-.01-68.269V86.716 68.245 57.758a5.653 5.653 0 01.138-1.2A5.33 5.33 0 01265.9 54.4a5.39 5.39 0 011.92-1.453 5.452 5.452 0 012.363-.448l141.536.013h2.036a17.374 17.374 0 012.048.061 6.228 6.228 0 015.367 5.481c.061.689.034 1.347.04 2.013V77.737q0 15.457-.009 29.982l-.021 53.819-.055 77.936-.016 12.229-.009 4.9v2.137a6.6 6.6 0 01-.194 1.916 5.642 5.642 0 01-3.62 3.891 5.519 5.519 0 01-1.375.283c-.314.013-.473.015-.473.015'
        data-name='Path 59407'
        transform='translate(-19472.021 11316.74)'
      ></path>
      <path
        fill='#eff5ff'
        d='M324.324 316.863a16.245 16.245 0 11-16.5-16.056 16.305 16.305 0 0116.5 16.056m-24.01.387a7.767 7.767 0 107.641-7.927 7.793 7.793 0 00-7.641 7.927'
        data-name='Path 59408'
        transform='translate(-19480.943 11235.108)'
      ></path>
      <path
        fill='#c5d7f2'
        d='M332.152 316.863a16.3 16.3 0 01-15.982 16.58l-.136-8.516a7.8 7.8 0 00-.249-15.6l-.136-8.515a16.3 16.3 0 0116.5 16.055'
        data-name='Path 59409'
        transform='translate(-19488.771 11235.108)'
      ></path>
      <path
        fill='#00d297'
        d='M309.29 342.245a18.561 18.561 0 01-19.006-18.489l9.917-.16c.081 5.034 3.911 8.2 8.92 8.121z'
        data-name='Path 59410'
        transform='translate(-19480.434 11227.615)'
      ></path>
      <path
        fill='#c5d7f2'
        d='M357.092 319.339a16.245 16.245 0 1116.5 16.056 16.3 16.3 0 01-16.5-16.056m24.01-.387a7.767 7.767 0 10-7.641 7.928 7.793 7.793 0 007.641-7.928'
        data-name='Path 59411'
        transform='translate(-19502.396 11234.467)'
      ></path>
      <path
        fill='#00d297'
        d='M357.093 319.339a16.3 16.3 0 0115.982-16.58l.136 8.516a7.8 7.8 0 00.25 15.6l.136 8.515a16.3 16.3 0 01-16.5-16.055'
        data-name='Path 59412'
        transform='translate(-19502.396 11234.465)'
      ></path>
      <path
        fill='#eff5ff'
        d='M378.73 300.807a18.561 18.561 0 0119.006 18.493l-9.917.16c-.081-5.033-3.911-8.2-8.92-8.121z'
        data-name='Path 59413'
        transform='translate(-19509.51 11235.108)'
      ></path>
      <path
        fill='#c5d7f2'
        d='M441.32 301.119a16.245 16.245 0 11-16.056 16.5 16.305 16.305 0 0116.056-16.5m.387 24.01a7.767 7.767 0 10-7.927-7.641 7.793 7.793 0 007.927 7.641'
        data-name='Path 59414'
        transform='translate(-19524.809 11235.006)'
      ></path>
      <path
        fill='#00d297'
        d='M441.319 301.119A16.3 16.3 0 01457.9 317.1l-8.516.136a7.8 7.8 0 00-15.6.25l-8.515.136a16.3 16.3 0 0116.055-16.5'
        data-name='Path 59415'
        transform='translate(-19524.809 11235.006)'
      ></path>
      <path
        fill='#eff5ff'
        d='M466.7 322.757a18.561 18.561 0 01-18.489 19.006l-.16-9.917c5.034-.081 8.2-3.91 8.121-8.92z'
        data-name='Path 59416'
        transform='translate(-19532.301 11227.891)'
      ></path>
      <path
        fill='#fafafa'
        d='M159.89 22.653v43.082a2.914 2.914 0 002.91 2.915h46.22a2.915 2.915 0 002.915-2.915V22.653a2.914 2.914 0 00-2.915-2.914H162.8a2.914 2.914 0 00-2.914 2.914'
        data-name='Path 59417'
        transform='translate(-19437.566 11327.511)'
      ></path>
      <path
        fill='#263238'
        d='M159.822 22.577a1.931 1.931 0 01.029-.509 2.9 2.9 0 01.6-1.361 2.94 2.94 0 012.128-1.089c.964-.021 2.067-.015 3.313-.024l21.1-.056 14.571-.021h7.074a3.929 3.929 0 011.073.1 3.052 3.052 0 012.226 2.267 4.512 4.512 0 01.085 1.1v4.361c0 11.778.009 24.727.014 38.317a3.113 3.113 0 01-1.1 2.366 3.04 3.04 0 01-1.179.616 4.59 4.59 0 01-1.3.111h-14.777l-18.483-.011-8.607-.007c-1.4-.007-2.757.011-4.136-.017A3.059 3.059 0 01159.7 66c-.033-5.268 0-10.125 0-14.586l.056-21.1.032-5.736.017-1.492c.006-.336.018-.508.018-.508s.012.173.018.508.009.844.017 1.492l.033 5.736.056 21.1.039 14.555a2.764 2.764 0 002.506 2.446c1.326.023 2.721 0 4.109.009l8.607-.007 18.483-.011h14.777a4.242 4.242 0 001.206-.1 2.7 2.7 0 001.044-.546 2.761 2.761 0 00.975-2.1c0-13.591.009-26.539.014-38.317v-4.361a3.056 3.056 0 00-.475-1.949 2.762 2.762 0 00-1.6-1.122 3.573 3.573 0 00-1-.091h-7.074L187 19.787l-21.1-.056-3.308-.009a2.869 2.869 0 00-2.079 1.03 2.924 2.924 0 00-.624 1.322c-.064.329-.049.5-.064.5'
        data-name='Path 59418'
        transform='translate(-19437.498 11327.586)'
      ></path>
      <path
        fill='#263238'
        d='M205.092 81.8c0 .084-5.949.152-13.287.152s-13.289-.068-13.289-.152 5.949-.152 13.289-.152 13.287.068 13.287.152'
        data-name='Path 59419'
        transform='translate(-19443.689 11307.157)'
      ></path>
      <path
        fill='#263238'
        d='M202.073 85.439c0 .084-3.3.152-7.37.152s-7.37-.068-7.37-.152 3.3-.152 7.37-.152 7.37.068 7.37.152'
        data-name='Path 59420'
        transform='translate(-19446.588 11305.961)'
      ></path>
      <path
        fill='#c5d7f2'
        d='M199.832 53.6l13.211.182a13.153 13.153 0 01-13.211 12.778h-.078z'
        data-name='Path 59421'
        transform='translate(-19450.67 11316.378)'
      ></path>
      <path
        fill='#00d297'
        d='M190.286 44.454l-.186 12.958a12.964 12.964 0 1113.4-12.958z'
        data-name='Path 59422'
        transform='translate(-19443.215 11323.646)'
      ></path>
      <path
        fill='#fff'
        d='M165.567 128.5l-5.016.486a16.218 16.218 0 112.714-5.138v-.008z'
        data-name='Path 59423'
        transform='translate(-19428.273 11300.211)'
      ></path>
      <path
        fill='#263238'
        d='M165.607 128.171s-.062-.108-.166-.31l-.459-.893-1.739-3.423.131.007v.008a.075.075 0 01-.136-.063 16.227 16.227 0 00.425-7.879 16.3 16.3 0 00-5.5-9.273 16.014 16.014 0 00-24.389 4.741l-.452.877-.369.911a17.2 17.2 0 00-.6 1.853 16.08 16.08 0 0028.19 13.884l.053-.028 3.709-.313.971-.077c.221-.017.342-.021.342-.021a3.047 3.047 0 01-.308.042l-.947.109-3.754.409.051-.028a16.123 16.123 0 01-6.291 4.9 16.37 16.37 0 01-21.182-7.762 16.57 16.57 0 01-1.174-11.2 17.407 17.407 0 01.616-1.894l.377-.93.462-.9a16.334 16.334 0 0124.89-4.8 16.2 16.2 0 013.751 4.556 16 16 0 011.789 4.9 16.206 16.206 0 01-.51 7.968l-.135-.063v-.007a.075.075 0 01.1-.024.08.08 0 01.028.032l1.68 3.511.419.889a3.061 3.061 0 01.131.293'
        data-name='Path 59424'
        transform='translate(-19428.236 11300.37)'
      ></path>
      <path
        fill='#eff5ff'
        d='M0 0H2.476V6.979H0z'
        data-name='Rectangle 14826'
        transform='translate(-19274.672 11418.597)'
      ></path>
      <path
        fill='#eff5ff'
        d='M163 125.8h4.232l-2.161-2.237z'
        data-name='Path 59425'
        transform='translate(-19438.586 11293.376)'
      ></path>
      <path
        fill='#eff5ff'
        d='M0 0H3.315V19.351H0z'
        data-name='Rectangle 14827'
        transform='translate(-19281.635 11409.01)'
      ></path>
      <path
        fill='#eff5ff'
        d='M152.159 111.45h5.666l-2.893-2.985z'
        data-name='Path 59426'
        transform='translate(-19435.023 11298.342)'
      ></path>
      <path
        fill='#00d297'
        d='M154.72 129.42l-.024 1.82-1.625-.022.023-1.771a7.706 7.706 0 01-4.029-1.354l.92-1.971a6.571 6.571 0 003.139 1.2l.036-2.715c-1.8-.462-3.806-1.091-3.774-3.415.023-1.723 1.294-3.185 3.866-3.443l.024-1.8 1.625.021-.023 1.772a7.347 7.347 0 013.286 1.035l-.839 1.989a6.651 6.651 0 00-2.476-.879l-.036 2.763c1.8.446 3.773 1.075 3.743 3.366-.023 1.691-1.277 3.137-3.833 3.412m-1.529-7.206l.03-2.308c-.864.184-1.212.65-1.219 1.187-.007.569.476.884 1.189 1.12m2.743 3.955c.007-.569-.46-.884-1.155-1.138l-.03 2.243c.815-.168 1.178-.585 1.185-1.106'
        data-name='Path 59427'
        transform='translate(-19434.006 11295.885)'
      ></path>
      <path
        fill='#eff5ff'
        d='M0 0H2.858V8.057H0z'
        data-name='Rectangle 14828'
        transform='translate(-19288.766 11414.279)'
      ></path>
      <path
        fill='#eff5ff'
        d='M141.786 119.34h4.886l-2.494-2.582z'
        data-name='Path 59428'
        transform='translate(-19431.611 11295.614)'
      ></path>
    </g>
  </svg>
);

export default EmptyFinancesIcon;
